export const getEnding = (isENLang: boolean) => {
  return isENLang ? 'EN' : 'AR';
};
